import React from 'react';
import { LowerAvatarThread, UpperAvatarThread } from './styled';
export var PositionInGroup = /*#__PURE__*/function (PositionInGroup) {
  PositionInGroup["FIRST"] = "FIRST";
  PositionInGroup["MIDDLE"] = "MIDDLE";
  PositionInGroup["LAST"] = "LAST";
  return PositionInGroup;
}({});
export var AvatarThread = function AvatarThread(_ref) {
  var children = _ref.children,
    positionInGroup = _ref.positionInGroup;
  return /*#__PURE__*/React.createElement(React.Fragment, null, positionInGroup !== PositionInGroup.FIRST && /*#__PURE__*/React.createElement(UpperAvatarThread, {
    "data-testid": "upper-avatar-thread"
  }), children, positionInGroup !== PositionInGroup.LAST && /*#__PURE__*/React.createElement(LowerAvatarThread, {
    "data-testid": "lower-avatar-thread"
  }));
};